import { Trans } from '@lingui/react'
import { bool } from 'prop-types'
import { useSelector } from 'react-redux'

import { type IState } from 'types/redux/store'
import Button from 'views/components/atoms/Button'
import { NOTIFICATION_TYPES } from 'views/components/molecules/Notification'
import { getOutOfStockMessageList } from 'views/components/organisms/Cart/helper/hasMessages'
import { NotificationCart } from 'views/components/organisms/Cart/NotificationCart'
import { hasErxServiceUnavailableError } from 'views/components/organisms/Cart/NotificationOrderDraft/hasOrderDraftError'
import { NotificationOutOfStock } from 'views/components/organisms/Cart/NotificationOutOfStock'
import { LOGIN_MODAL_ID } from 'views/consts'

type EmptyCartHeaderProps = {
  loggedInUser: boolean
  continueShoppingLink: string
}

const EmptyCartHeader = ({
  loggedInUser,
  continueShoppingLink,
}: EmptyCartHeaderProps) => {
  const outOfStockMessageList = useSelector((state: IState) =>
    getOutOfStockMessageList(state.cart.data.messages)
  )

  const error = useSelector((state: IState) => state.cart.error)

  return (
    <>
      {hasErxServiceUnavailableError(error) && (
        <NotificationCart type={NOTIFICATION_TYPES.INFO}>
          <Trans id="cart.notification.erx.unavailable" />
        </NotificationCart>
      )}
      {outOfStockMessageList.length > 0 && (
        <NotificationOutOfStock messages={outOfStockMessageList} />
      )}
      <div className="a-box u-no-padding u-padding-large u-text-align--center@medium u-background-color--greySky o-EmptyCartHeaderContainer u-no-margin--bottom">
        <h3
          className={`a-h3 o-EmptyCartHeaderContainer__header--first-line ${
            loggedInUser
              ? 'a-h3--loggedIn o-EmptyCartHeaderContainer__header--first-line-logged-in'
              : 'u-no-margin--bottom'
          } `}
        >
          <Trans id="general.cart.empty" />
        </h3>
        {loggedInUser ? (
          <div className="m-EmptyCartHeader__ContinueButton-container-loggedIn">
            <Button
              name="continue-shopping"
              style="buttonPrimary"
              href={continueShoppingLink}
            >
              <Trans id="general.link.label.continueShopping" />
            </Button>
          </div>
        ) : (
          <>
            <h2 className="a-h2 u-no-overflow o-EmptyCartHeaderContainer__header--second-line">
              <Trans id="general.cart.empty.missingProducts" />
            </h2>
            <div className="m-EmptyCartHeader__LoggedOutButtons-container">
              <div className="u-margin-small--bottom m-EmptyCartHeader__LoginButton-container">
                <Button
                  name="login"
                  style="buttonPrimary"
                  data-a11y-dialog-show={LOGIN_MODAL_ID}
                  isClientsideControlled
                >
                  <Trans id="general.link.label.loginNow" />
                </Button>
              </div>
              <div className="m-EmptyCartHeader__ContinueButton-container">
                <Button
                  name="continue-shopping"
                  style="buttonGhost"
                  href={continueShoppingLink}
                >
                  <Trans id="general.link.label.continueShopping" />
                </Button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )
}

EmptyCartHeader.propTypes = {
  loggedInUser: bool,
}

EmptyCartHeader.defaultProps = {
  loggedInUser: false,
}

export default EmptyCartHeader

// Jetzt anmelden anstatt Jetzt einloggen (s.Z.: 34)
// Weiter einkaufen anstatt Weiter shoppen (s.Z.: 26, 38)
